module.exports = __webpack_public_path__ + "static/media/maternity.e701510b.svg";